import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { colors, breakpoints } from 'globalStyles'

const StyledPopUp = styled(Modal)`
  .modal-header {
    background-color: ${colors.translucent_light_blue};
    padding: 0px;
    justify-content: center;
  }
  .modal-body {
    text-align: center;
    padding: 24px 16px 16px 16px;

    @media only screen and ${breakpoints.desktop} {
      padding: 24px;
    }

    > * {
      display: flex; /* or 'grid' */
      flex-direction: column; /* stack children vertically */
      gap: 16px; /* Adjust this value to control spacing */
      padding-bottom: 0px; /* Optional padding around all children */
    }

    /* Remove the last child's bottom margin */
    > *:last-child {
      margin-bottom: 0;
    }
  }
  .modal-footer {
    border-top: none;
    display: flex;
    flex-direction: column;
    margin: 16px 16px 24px;
    padding 0px;

    @media only screen and ${breakpoints.desktop} {
      margin: 0px 24px 24px;
    }

    > * { 
      margin: 0px;
    }
  }
  .footer-buttons-row {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .footer-buttons-row.centered {
    justify-content: center;
  }
  .footer-buttons-row:not(.centered) {
    justify-content: space-between;
  }
  .alternative-style {
    border-top: none;
    display: flex;
    flex-direction: column;
    margin: 8px 0px 24px;
    padding: 0px;
    width: 100%;
    Button {
      width: 95%;
    }
  }
  .modal-title {
    font-weight: 600;
    font-size: 20px;
    padding: 24px;
  }
  .icon-padding {
    padding-right: 12px;
    width: 30px;
  }
  .title-text {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .modal-content {
    width: 100%;
    height: auto;
  }

  .modal-content {
    width: 100%;
  }

  .modal-dialog {
    width: 330px;
    max-width: 100%;
    margin: 0.5rem auto;

    @media only screen and ${breakpoints.desktop} {
      width: 500px;
    }
  }
  .popup-primary-btn,
  .popup-secondary-btn {
    width: 48%;
  }

  .popup-primary-btn button,
  .popup-secondary-btn button {
    width: 100%;
  }
  /* div.fade.in.modal {
    display: flex !important;
  } */
`

const PopUp = ({
  children,
  title,
  icon,
  iconWidth,
  primaryButton, // primary
  secondaryButton, // secondary
  size,
  show,
  onHide,
  footerStyling,
  footerContent,
  bodyStyle,
  className,
}) => {
  const handleClose = () => onHide(false)
  const titleRef = useRef(null)
  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.focus()
    }
  }, [])
  return (
    <StyledPopUp
      show={show}
      size={size}
      onHide={handleClose}
      backdrop="static"
      centered
      className={className}
    >
      {title !== null && (
        <StyledPopUp.Header>
          <StyledPopUp.Title autoFocus>
            <div className="title-text">
              {icon && <img className="icon-padding" src={icon} alt="icon-img" width={iconWidth} />}
              <div ref={titleRef} tabIndex="-1">
                {title}
              </div>
            </div>
          </StyledPopUp.Title>
        </StyledPopUp.Header>
      )}
      <StyledPopUp.Body style={bodyStyle}>{children}</StyledPopUp.Body>
      <StyledPopUp.Footer className={footerStyling ? 'alternative-style' : ''}>
        <div className={`footer-buttons-row${!secondaryButton ? ' centered' : ''}`}>
          <div className="popup-primary-btn">{primaryButton}</div>
          {secondaryButton && <div className="popup-secondary-btn">{secondaryButton}</div>}
        </div>
        {footerContent}
      </StyledPopUp.Footer>
    </StyledPopUp>
  )
}

PopUp.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  iconWidth: PropTypes.string,
  primaryButton: PropTypes.node,
  secondaryButton: PropTypes.node,
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func,
  footerStyling: PropTypes.bool,
  footerContent: PropTypes.node,
  bodyStyle: PropTypes.shape({}),
  className: PropTypes.string,
}

PopUp.defaultProps = {
  title: '',
  icon: '',
  iconWidth: '',
  primaryButton: null,
  secondaryButton: null,
  size: 'md',
  onHide: null,
  footerStyling: null,
  footerContent: null,
  bodyStyle: undefined,
  className: '',
}

export default PopUp
